export default [{
  id: 'rsrc.column.path',
  cell: {
    font: {
      size: null,
      type: 'style.Font',
      style: null,
      family: null,
      weight: null
    },
    wrap: false,
    align: 'center',
    color: null,
    justify: 'right',
    background: null,
    emptyValue: null
  },
  type: 'attr.column.string',
  width: null,
  header: {
    font: {
      size: null,
      type: 'style.Font',
      style: null,
      family: null,
      weight: null
    },
    wrap: false,
    align: 'center',
    color: null,
    label: 'Path',
    justify: 'left',
    background: null
  },
  attrName: 'rsrc.path',
  maxWidth: null,
  minWidth: null,
  objectType: 'rsrc'
}, {
  id: 'rsrc.column.type',
  cell: {
    font: {
      size: null,
      type: 'style.Font',
      style: null,
      family: null,
      weight: null
    },
    wrap: false,
    align: 'center',
    color: null,
    justify: 'right',
    background: null,
    emptyValue: null
  },
  type: 'attr.column.string',
  width: null,
  header: {
    font: {
      size: null,
      type: 'style.Font',
      style: null,
      family: null,
      weight: null
    },
    wrap: false,
    align: 'center',
    color: null,
    label: 'Type',
    justify: 'left',
    background: null
  },
  attrName: 'rsrc.type',
  maxWidth: null,
  minWidth: null,
  objectType: 'rsrc'
}, {
  id: 'rsrc.column.ownerId',
  cell: {
    font: {
      size: null,
      type: 'style.Font',
      style: null,
      family: null,
      weight: null
    },
    wrap: false,
    align: 'center',
    color: null,
    justify: 'right',
    background: null,
    emptyValue: null
  },
  type: 'attr.column.string',
  width: null,
  header: {
    font: {
      size: null,
      type: 'style.Font',
      style: null,
      family: null,
      weight: null
    },
    wrap: false,
    align: 'center',
    color: null,
    label: 'OwnerId',
    justify: 'left',
    background: null
  },
  attrName: 'rsrc.ownerId',
  maxWidth: null,
  minWidth: null,
  objectType: 'rsrc'
}, {
  id: 'rsrc.column.coownerId',
  cell: {
    font: {
      size: null,
      type: 'style.Font',
      style: null,
      family: null,
      weight: null
    },
    wrap: false,
    align: 'center',
    color: null,
    justify: 'right',
    background: null,
    emptyValue: null
  },
  type: 'attr.column.string',
  width: null,
  header: {
    font: {
      size: null,
      type: 'style.Font',
      style: null,
      family: null,
      weight: null
    },
    wrap: false,
    align: 'center',
    color: null,
    label: 'CoownerId',
    justify: 'left',
    background: null
  },
  attrName: 'rsrc.coownerId',
  maxWidth: null,
  minWidth: null,
  objectType: 'rsrc'
}, {
  id: 'rsrc.column.createdAt',
  cell: {
    font: {
      size: null,
      type: 'style.Font',
      style: null,
      family: null,
      weight: null
    },
    wrap: false,
    align: 'center',
    color: null,
    justify: 'right',
    background: null,
    emptyValue: null
  },
  formatter: {
    type: 'attr.formatter.timestamp',
    format: 'M/d h:mm a'
  },
  type: 'attr.column.Generic',
  width: null,
  header: {
    font: {
      size: null,
      type: 'style.Font',
      style: null,
      family: null,
      weight: null
    },
    wrap: false,
    align: 'center',
    color: null,
    label: 'Created At',
    justify: 'left',
    background: null
  },
  attrName: 'rsrc.createdAt',
  maxWidth: null,
  minWidth: null,
  objectType: 'rsrc'
}, {
  id: 'rsrc.column.updatedAt',
  cell: {
    font: {
      size: null,
      type: 'style.Font',
      style: null,
      family: null,
      weight: null
    },
    wrap: false,
    align: 'center',
    color: null,
    justify: 'right',
    background: null,
    emptyValue: null
  },
  formatter: {
    type: 'attr.formatter.timestamp',
    format: 'M/d h:mm a'
  },
  type: 'attr.column.Generic',
  width: null,
  header: {
    font: {
      size: null,
      type: 'style.Font',
      style: null,
      family: null,
      weight: null
    },
    wrap: false,
    align: 'center',
    color: null,
    label: 'Updated At',
    justify: 'left',
    background: null
  },
  attrName: 'rsrc.updatedAt',
  maxWidth: null,
  minWidth: null,
  objectType: 'rsrc'
}];